/** This is the constants */
//例：export const GET_LAWYER = '/api/get/law'

// 案由模糊查询
export const ANLASSFALL = '/api/kw/base/matter/metas/key';
// 法院
export const GETCOURT = '/api/kw/base/court/map';
// 是否合作
export const EXPERIENCE = '/api/kw/h5/kw/lawyers/cooperation/types';
// 律所模糊查询
export const LOWOFFICE = '/api/kw/h5/kw/firms/headers';
// 侯选库/
export const LIBRATY = '/api/kw/H5/candidateLibrary';
// 添加侯选库
export const CREATELIBRATY = '/api/kw/H5/candidateLibrary';
// 侯选库详情
export const LIBRATYDETAIL = '/api/kw/H5/candidateLibrary/detail';
// 侯选库律师列表
export const LAWYERLIST = '/api/kw/h5/kw/lawyers/stored';
// 删除侯选库
export const REMOVELIBRATY = '/api/kw/H5/candidateLibrary/del';
// 修改侯选库
export const UPDATALIBRATY = '/api/kw/H5/candidateLibrary';
// 案由查询律师
export const REASON = '/api/kw/h5/kw/lawyers';
// 侯选库列表
export const LIBRATYLIST = '/api/kw/H5/candidateLibrary/list';
// 添加律师到侯选库
export const ADDREASON = '/api/kw/H5/candidateLibrary/add/lawyer';
// 获取工作经历
export const COOP = '/api/kw/h5/kw/lawyers/work/experience/types';
// 获取获奖荣誉
export const HONOR = '/api/kw/h5/kw/firms/honors/types';
// 获取工作年限
export const LINCENSE = '/api/kw/h5/kw/lawyers/career/types';
// 律师基本信息
export const BASEINFO = '/api/kw/H5/lawyer/base/info';
// 律所列表
export const COURTLIST = '/api/kw/h5/kw/firms';
// 最近委案记录
export const CASEANALYZE = '/api/kw/h5/kw/firms/cases/analysis';
// 获得好评标签
export const GOODLABLES = '/api/kw/kw/commons/comments/good/labels';
// 获得差评标签
export const BADLABLES = '/api/kw/kw/commons/comments/bad/labels';
// 添加律所评价
export const FIRMEVADATE = '/api/kw/h5/kw/firms/comments';
// 律所评价
export const ALLEVA = '/api/kw/h5/kw/firms/comments/group';
// 律所集团评价
export const MYSELFEVA = '/api/kw/h5/kw/firms/comments/global';
// 律所荣誉
export const LAWFIRMHONOR = '/api/kw/H5//lawyer/firm/honor';
// 律所全部案例
export const LAWFIRMALLCASE = '/api/kw/h5/kw/firms/cases';
// 律师全部案例
export const ALLCASE = '/api/kw/h5/kw/lawyers/cases';
// 律师全部案例
export const NOALLCASE = '/api/kw/spec/tiny/lawyers/cases';
// 律师案例列表
export const LAWYER_CASES_LISTS = '/api/pf/profile/h5/lawyer/cases/items';
// 律师案例列表 - 分享
export const LAWYER_CASES_LISTS_OUTER = '/api/pf/profile/outer/lawyer/cases/items';
// 律师所有评价
export const LAWYEREVA = '/api/kw/h5/kw/lawyers/comments/global';
// 律师集团评价
export const ATTORENYEVA = '/api/kw/h5/kw/lawyers/comments/group';
// 律师基本信息
export const ATTORENYINFO = '/api/kw/h5/kw/lawyers/meta/details';
// 律师所有荣誉
export const ATTORNEYHONOR = '/api/kw/H5/lawyer/lawyer/honor';
// 律师最近委案记录
export const ATTORENYCASE = '/api/kw/H5/lawyer/lawyer/caseAnalyze';
// 添加律师评价
export const ATTORENYEVADATE = '/api/kw/h5/kw/lawyers/comments';
// 获取地域信息
export const BASEREGION = '/api/kw/H5/base/region';
// 律师办案详情
export const LAWYERCASEANALYZE = '/api/kw/h5/kw/lawyers/cases/analysis';
// 移除侯选库
export const DELETELAWYER = '/api/kw/H5/candidateLibrary/delete/lawyer';
// 企业律所库
export const INSTOCK = '/api/kw/h5/kw/firms/subscribed/within/tag';
// 获取省
export const BASEAREAS = '/api/kw/base/region/provinces';
// 获取市
export const GETCITYS = '/api/kw/base/region/provinces/cities';
// 根据市获得省
export const PRONAME = '/api/kw/H5/base/pro/name';
// 获取合作案件数
export const COURTINFO = '/api/kw/H5/lawyer/court/info';
// 律所联系方式
export const LAWCONTATC = '/api/kw/H5/lawyer/lawfirm/contact';
// 律师联系方式
export const CONTATCT = '/api/kw/H5/lawyer/contact';
// 获取律所Time
// export const FIRMTIME = '/api/H5/lawyer/firm/time';
// 移除律师
export const LAWYERSPEC = '/api/kw/H5/candidateLibrary/delete/lawyer/spec';
// 获取全部案件总数
// export const CASENUMBER = '/api/kw/h5/kw/cases/count';
export const CASENUMBER = '/api/tg/lawsearch-platform/judgements/count';
// 案件列表
export const CASELIST = '/api/tg/platform/lawcase/h5/cases/items';
// 案件详情上
export const CASEDETAILS = '/api/tg/platform/lawcase/h5/cases/detail';
// 案件详情下
export const CASEDETAILSBOTTOM = '/api/tg/platform/lawcase/mini/cases/nodes';
// 案件阶段
export const CASESTAGE = '/api/tg/platform/lawcase/h5/cases/visual/stages';
// 案件状态
export const CASESTATUS = '/api/tg/platform/lawcase/h5/cases/status';
// 案件结案状态
export const CASEEND = '/api/kw/h5/lawcase/case/end/status';
// 侯选库更新的num
export const UPDATENUMBERR = '/api/kw/H5/candidateLibrary/updated/count';
// 律所本集团评价
export const COLLECTEVA = '/api/kw/H5/lawyer/firm/collect/eva';
// 首页埋点
export const STATISTIC = '/api/kw/statistic/click';
// 律师案件筛选条件
export const CASESHEADER = '/api/kw/h5/kw/lawyers/cases/headers';
// 律师案件筛选条件无token
export const NOCASESHEADER = '/api/kw/spec/tiny/lawyers/cases/headers';
// 律师案例顶部条件 - 预览
export const LAWYER_CASES_HEADER_CONDITIONS = '/api/pf/profile/h5/lawyer/cases/header/conditions';
// 律师案例顶部条件 - 分享
export const LAWYER_CASES_HEADER_CONDITIONS_OUTER = '/api/pf/profile/outer/lawyer/cases/header/conditions';
// 律所详情
export const LAWDETAIL = '/api/kw/h5/kw/firms/meta/details';
// 律所案件筛选条件
export const LAWANALYSIS = '/api/kw/h5/kw/firms/cases/headers';
// 验证身份
export const LOGIN = '/api/kw/login/status';
// 委托办案
// export const ENQUIRY = '/api/kw/lawcase/case/enquiry/handle';
// a:猜你喜欢  b:我TM不喜欢
export const RECOMMENDS = '/api/kw/h5/kw/lawyers/recommends';
// 最近咨询
export const EWCENTLY = '/api/kw/h5/kw/lawyers/contact/recently';
// 代理程序
export const PROGRAMS = '/api/tg/platform/lawcase/h5/cases/proxy/programs';
// 案件状态TYPE
export const EXTRASTATUS = '/api/tg/platform/lawcase/h5/cases/extra/status';
// 代办理案件
export const TODEAL = '/api/kw/lawcase/case/to/deal';
// 催促办理
export const URGESEND = '/api/kw/lawcase/case/urge/send';
// 删除案件
export const DELETECASE = '/api/kw/lawcase/case/deal/delete';

//im
export const GET_IM_MESSAGE = 'get_im_message';
export const GET_NUM_NOTICE = 'get_num_notice';
//use to get lawyerInfo(im)
export const IM_LAWYER_INFO = '/api/kw/kw/im/lawyer/info';
//办案
export const ENTRUST_CASE = '/api/kw/lawcase/case/enquiry/handle';

// 案件程序
export const PROXYPROCESS = '/api/tg/platform/lawcase/mini/cases/proxy/programs';
// 诉讼地位
export const LITIGATION = '/api/tg/platform/lawcase/mini/cases/litigation';
// 争议解决机构
export const ORGANIZATIONS = '/api/tg/platform/lawcase/mini/cases/proxy/program/agencies';
// 新建案件
export const ADDCASE = '/api/tg/platform/lawcase/h5/cases';

// 模糊搜索律师
export const LAWYERHEADERS = '/api/kw/h5/kw/lawyers/headers';
// 企业律所库
export const DYNAMIC = '/api/tg/platform/lawcase/h5/cases/actions';

export const HONOR_LIST_LAWYER = '/api/tg/r/p/laf/api/lawyers/card/honors/user';
// 名片头像上传
export const UPLOAD_USER_AVATAR = '/api/tg/auth/v2/user/headUpload';
// 名片-获取最近一次委案
export const CARDCASE = '/api/tg/r/p/laf/api/lawyers/card/cases/user';
// 名片-律师下律所介绍
export const FIRMUSER = '/api/tg/r/p/laf/api/lawyers/card/firm/user';
// 获取律所信息 - 预览
export const GET_LAWYER_FIRM_PREVIEW = '/api/pf/profile/h5/lawyer/firm/preview';
// 获取律所信息 - 编辑
export const GET_LAWYER_FIRM_EDIT = '/api/pf/profile/h5/lawyer/firm/editable';
// 获取律所信息 - 分享
export const GET_LAWYER_FIRM_OUTER = '/api/pf/profile/outer/lawyer/firm';
// 名片-律师荣誉
export const HONORUSER = '/api/tg/r/p/laf/api/lawyers/card/honors/user';
// 业界荣誉列表
export const LAWYER_HONOR_LIST = '/api/pf/profile/h5/lawyer/honors';
// 业界荣誉列表 - 分享
export const LAWYER_HONOR_LIST_OUTER = '/api/pf/profile/outer/lawyer/honors';
// 名片-机构
export const CARDHONORS = '/api/tg/r/p/laf/api/lawyers/card/honors/types';
// 业界荣誉机构
export const LAWYER_HONOR_ORGANIZATION = '/api/pf/profile/h5/lawyer/honor/types';
// 名片-荣誉新增编辑
export const UPDATAHONOR = '/api/tg/r/p/laf/api/lawyers/card/honors';
// 新增业界荣誉
export const ADD_LAWYER_HONOR = '/api/pf/profile/h5/lawyer/honor';
// 编辑业界荣誉
export const EDIT_LAWYER_HONOR = '/api/pf/profile/h5/lawyer/u/honor';
// 名片-删除荣誉
export const REMOVEHONOR = '/api/tg/r/p/laf/api/lawyers/card/d/honors';
// 删除律师荣誉
export const DELETE_LAWYER_HONOR = '/api/pf/profile/h5/lawyer/d/honor';
// 名片-显示隐藏
export const FUNCTIONSTATUS = '/api/tg/r/p/laf/api/lawyers/card/function/status';
// 名片-荣誉详细信息
export const CARDHONOR = '/api/tg/r/p/laf/api/lawyers/card/honor';
// 通过ID获取律师荣誉 - 编辑
export const GET_LAWYER_HONOR_BY_ID = '/api/pf/profile/h5/lawyer/honor/editable';
// 图片转base64
export const GETBASEIMG = '/api/tg/r/p/laf/api/lawyers/card/image/encode';
// 获取律师名片信息
export const GET_CALLING_CARD_DETAIL = '/api/tg/r/p/laf/api/lawyers/card/user';
// 获取律师名片头部信息 - 预览/编辑
export const GET_LAWYER_HEADER_DETAIL = '/api/pf/profile/h5/lawyer/header';
// 获取律师名片头部信息 - 分享
export const GET_LAWYER_HEADER_DETAIL_OUTER = '/api/pf/profile/outer/lawyer/header';
//card-get工作和教育
export const GET_CARD_EDUCAT = '/api/tg/r/p/laf/api/lawyers/extra/card/user';
// 工作经历
export const GET_LAWYER_WORKS = '/api/pf/profile/h5/lawyer/works';
// 工作经历 - 分享
export const GET_LAWYER_WORKS_OUTER = '/api/pf/profile/outer/lawyer/works';
// 教育经历
export const GET_LAWYER_EDUCATIONS = '/api/pf/profile/h5/lawyer/educations';
// 教育经历 - 分享
export const GET_LAWYER_EDUCATIONS_OUTER = '/api/pf/profile/outer/lawyer/educations';
//edit or add work
export const EDIT_OR_ADD_WORK = '/api/tg/r/p/laf/api/lawyers/card/work';
// 添加工作经历
export const ADD_LAWYER_WORK = '/api/pf/profile/h5/lawyer/work';
// 添加教育经历
export const ADD_LAWYER_EDUCATION = '/api/pf/profile/h5/lawyer/education';
// 编辑工作经历
export const EDIT_LAWYER_WORK = '/api/pf/profile/h5/lawyer/u/work';
// 编辑教育经历
export const EDIT_LAWYER_EDUCATION = '/api/pf/profile/lawyer/u/education';
//delete work
export const DELETE_CARD_WORK = '/api/tg/r/p/laf/api/lawyers/card/d/work';
// 删除工作经历
export const DELETE_LAWYER_WORK = '/api/pf/profile/h5/lawyer/d/work';
// 删除教育经历
export const DELETE_LAWYER_EDUCATION = '/api/pf/profile/h5/lawyer/d/education';
// 职位类型
export const CARD_WORK_TYPES = '/api/tg/r/p/laf/api/lawyers/card/work/types';
// 职位类型 - 通过机构类型联动
export const LAWYER_WORK_POSITIONS_TYPES = '/api/pf/profile/h5/lawyer/positions';
//工作机构
export const CARD_WORK_ORGANZTION = '/api/tg/r/p/laf/api/lawyers/card/work/organization/types';
// 工作机构类型
export const LAWYER_WORK_ORGANIZATION_TYPES = '/api/pf/profile/h5/lawyer/work/organization/types';
//ID查律师工作经历
export const PASS_ID_GETWORK_MSG = '/api/tg/r/p/laf/api/lawyers/card/work';
// 通过id获取律师工作经历
export const GET_LAWYER_WORK_BY_ID = '/api/pf/profile/h5/lawyer/work';
// 通过id获取律师教育经历
export const GET_LAWYER_EDUCATION_BY_ID = '/api/pf/profile/h5/lawyer/education';
//edit or add education
export const EDIT_OR_ADD_EDUCATION = '/api/tg/r/p/laf/api/lawyers/card/education';
//delete education
export const DELETE_CARD_EDUCATION = '/api/tg/r/p/laf/api/lawyers/card/d/education';
//学位类型
export const CARD_EDUCATION_TYPES = '/api/tg/r/p/laf/api/lawyers/card/education/background/types';
// 学位等级
export const LAWYER_EDUCATION_BACKGROUND_TYPES = '/api/pf/profile/h5/lawyer/education/background/types';
//ID查律师教育经历
export const PASS_ID_GETEDUCATION_MSG = '/api/tg/r/p/laf/api/lawyers/card/education';
// 天工通过手机号获取律师信息（getLawerProfileInfoByPhoneNum=>getLawerProfileInfoByIdentifier）
export const TG_GET_LAWYER_DETAILS = '/api/tg/auth/lawyer/getLawerProfileInfoByIdentifier';
// export const TG_GET_LAWYER_DETAILS = '/api/tg/auth/lawyer/getLawerProfileInfoByPhoneNum';
// 代办日程 月的数据接口
export const CALENDAR_LISTALL = '/api/tg/lawcase/schedule/listAll';
// 待办日程 提醒时间设置
export const REMINDTYPE = '/api/tg/lawcase/dict/schedule/remindtype';
// 查询某天待办事项
export const LIST_DAY_AGENTS = '/api/tg/lawcase/schedule/listDayAgentsH5';
// 完成代办事项
export const COMPLETE_MODIFY = '/api/tg/lawcase/schedule/modify';
// 首页待办日程列表
export const LIST_HOME = '/api/tg/lawcase/schedule/listHome';
// 获取用户案件列表
export const LISTCASENAMES = '/api/tg/lawcase/schedule/listCaseNames';
// 获取按键动作
export const LISTCARDNAMES = '/api/tg/lawcase/schedule/listCardNames';
// 获取团队成员
export const CASEMEMBER = '/api/tg/lawcase/schedule/listCaseTeamUsers';
// 新建日程
export const ADD_SCHEDULE = '/api/tg/lawcase/schedule/add';
// 编辑回显
export const EDITPAGE = '/api/tg/lawcase/schedule/editpage';
// 删除待办日程
export const SCHEDULE_DELETE = '/api/tg/lawcase/schedule/delete';
// 手机号判断身份（获取用户信息）
export const PLATFROM_CHECK = '/api/tg/auth/platform/check';
// 律师自注册 delete
export const GET_USERINFO = '/api/tg/auth/air/user/getUserInfoByPhone4App';
// 获取律师信息（delete）
export const GET_LAWERINFO = '/api/tg/auth/lawyer/getLawerProfileInfoByPhoneNum';
// 律师认证信息提交 - 官网后端
export const SAVE_LAWYER_AUTH = '/newOfficialWebsite/lawyerauth/saveLawyerAuth';
// 律师认证上传图片 - 官网后端
export const UPLOAD_LAWYER_PICTURE = '/newOfficialWebsite/lawyerauth/uploadPicture';
// 判断律师账号有效期(接口在项目中没有调用)
// export const USER_TERM = '/api/tg/auth/h5/check/user/term';
// 律师认证-头像上传
export const HEADER_AVATAR = '/api/tg/auth/v2/user/headUpload';
// 律师的基本信息
export const BASE_INFO = '/api/tg/auth/v2/user/base/info';
// 律师认证状态
export const LAWYER_AUTHORIZATION_STATE = '/api/pf/user/lawyer/authorization/state';
// 律师认证状态 - 案例
export const LAWYER_AUTHORIZATION_STATE_CASE =
    '/interface/api/ws/app_interface/authorization/outer/auth/status';
// 律师认证页面基本信息
export const LAWYER_AUTHORIZATION_INFO = '/api/pf/user/h5/lawyer/authorization/data';
// 律师认证页面基本信息 - 案例
export const LAWYER_AUTHORIZATION_INFO_CASE =
    '/interface/api/ws/app_interface/authorization/outer/lawyer/auth/info';
// 律师认证提交接口
export const LAW_INFO_UPDATE = '/api/tg/auth/v2/user/info/update';
// 律师认证提交接口
export const LAWYER_AUTHORIZATION_SUBMIT = '/api/pf/user/h5/lawyer/authorization';
// 律师认证提交接口 - 案例
export const LAWYER_AUTHORIZATION_SUBMIT_CASE =
    '/interface/api/ws/app_interface/authorization/outer/lawyer/auth/save';
// 律师执业证书上传
export const LICENSE_UPLOAD = '/api/tg/auth/v2/user/licenseUpload';
// 律师手持身份证上传
export const CARD_UPLOAD = '/api/tg/auth/v2/user/cardUpload';
// 律师认证上传图片 - 案例
export const LAWYER_FILE_UPLOAD = '/interface/api/ws/app_interface/authorization/outer/lawyer/auth/upload';
// 律师未认证 和 律师认证失败提醒
export const MINI_TIPS = '/api/tg/platform/record/lawyer/aut/mini/tips';
// 律师现有职位
// export const POSITION_TYPES = '/api/tg/platform/laf/h5/lawyer/card/position/types';
export const POSITION_TYPES = '/api/pf/profile/h5/lawyer/position/types';
// 律师现有职位 - 案例
export const POSITION_TYPES_CASE = '/interface/api/ws/app_interface/authorization/outer/positions';
// 确认认证提示
export const MINI_TIPS_POST = '/api/tg/platform/record/lawyer/aut/mini/tips';
// 律师名片-过往客户
export const CARD_COOPERATION = '/api/tg/platform/laf/h5/lawyer/card/cooperation';
// 律师名片-过往客户-预览
export const SPEC_CARD_COOPERTION = '/api/tg/platform/laf/spec/h5/lawyer/card/cooperation';
// 律师合作客户列表 - 预览/编辑
export const LAWYER_COOPERATION_LIST = '/api/pf/profile/h5/lawyer/simple/cooperation/data';
// 律师合作客户列表 - 分享
export const LAWYER_COOPERATION_LIST_OUTER = '/api/pf/profile/outer/lawyer/simple/cooperation/data';
// 律师名片-分享次数
export const SHARE_COUNT = '/api/tg/platform/laf/spec/h5/lawyer/card/share/count';

// 律师名片根据code获取信息
// 律师名片分享获取简略信息
export const GET_SINGPLE_LAWYER_INFO = '/api/tg/platform/laf/spec/h5/lawyer/code';
// 律师名片分享获取简略信息(code、name、photo等) - 预览
export const GET_LAWYER_SHARE_SIMPLE_PROFILE = '/api/pf/profile/h5/lawyer/simple/profile';
// 律师名片分享获取简略信息(code、name、photo等) - 分享
export const GET_LAWYER_SHARE_SIMPLE_PROFILE_OUTER = '/api/pf/profile/outer/lawyer/simple/profile';
//律师header
export const GET_LAWYER_HEADER = '/api/tg/platform/laf/spec/h5/card/user';
//律所信息
export const GET_COURT_INFO_CD = '/api/tg/platform/laf/spec/h5/card/firm/user';
//合作信息
export const GET_COOP_INFO_CD = '/api/tg/platform/laf/spec/h5/lawyer/card/cooperation/list';
//工作和教育
export const GET_WORKS_EDUCATION_CD = '/api/tg/platform/laf/spec/h5/extra/card/user';
//荣誉
export const GET_HONORS_CD = '/api/tg/platform/laf/spec/h5/card/honors/user';
//最新案例
export const GET_LAST_CASE_CD = '/api/tg/platform/laf/spec/h5/card/cases/user';
//二次分享
export const GET_SHARE_SIGNATURE = '/api/kw/spec/kw/wechat/h5/lawyer/signature';

// 办案分析 - 预览
export const CASES_ANALYSIS_COUNT_PREVIEW = '/api/pf/profile/h5/lawyer/cases/analysis/count/preview';

// 办案分析 - 编辑
export const CASES_ANALYSIS_COUNT_EDIT = '/api/pf/profile/h5/lawyer/cases/analysis/count/editable';

// 办案分析 - 分享
export const CASES_ANALYSIS_COUNT_OUTER = '/api/pf/profile/outer/lawyer/cases/analysis/count';

// 学习成长 - 课程 - 预览
// export const GET_LAWYER_COURSES_LIST = '/api/pf/profile/h5/lawyer/courses';
export const GET_LAWYER_COURSES_LIST = '/api/pf/profile/h5/lawyer/courses/preview';
// 学习成长 - 课程 - 编辑
export const GET_LAWYER_COURSES_LIST_EDIT = '/api/pf/profile/h5/lawyer/courses/editable';
// 学习成长 - 课程 - 分享
export const GET_LAWYER_COURSES_LIST_OUTER = '/api/pf/profile/outer/lawyer/courses';

// 名片编辑状态下 - 关闭
export const LAWYER_FUNCTION_CLOSE = '/api/pf/profile/h5/lawyer/function/close';

// 名片编辑状态下 - 打开
export const LAWYER_FUNCTION_OPEN = '/api/pf/profile/h5/lawyer/function/open';

// 获取名片token
export const GET_LAWYER_CASE_TOKEN =
    '/interface/api/ws/app_interface/authorization/outer/lawyer/auth/profile/passtoken';

// 注册Air
export const GET_USERINFO_BY_AIR = '/api/tg/auth/air/user/getUserInfoByPhone4App';
